// extracted by mini-css-extract-plugin
module.exports =  {"template-23":"Template23-i3xx__template-23","audio-player--padded":"Template23-Jbsg__audio-player--padded"};